module.exports = __webpack_public_path__ + "static/api_key_view_no_customers-b5623a1411995cb5e987dd819113179e.png";